.ticket-search-wizard .qty-selector {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width: 500px) {
  .ticket-search-wizard .qty-selector {
    gap: 10px;
  }
}
.ticket-search-wizard .action-button {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}
@media screen and (max-width: 500px) {
  .ticket-search-wizard .action-button {
    flex-direction: column;
    gap: 10px;
  }
  .ticket-search-wizard .action-button button {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvb3JnYW5pc21zL2J1eXRpY2tldHMiLCJzb3VyY2VzIjpbInRpY2tldC1zZWFyY2gtd2l6YXJkLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUk7RUFDSTtFQUNBO0VBQ0E7O0FBRUE7RUFMSjtJQU1ROzs7QUFJUjtFQUNJO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBTko7SUFPUTtJQUNBOztFQUVBO0lBQ0kiLCJzb3VyY2VzQ29udGVudCI6WyIudGlja2V0LXNlYXJjaC13aXphcmQge1xuXG4gICAgLnF0eS1zZWxlY3RvciB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGdhcDogMjBweDtcblxuICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA1MDBweCkge1xuICAgICAgICAgICAgZ2FwOiAxMHB4O1xuICAgICAgICB9XG4gICAgfVxuXG4gICAgLmFjdGlvbi1idXR0b24ge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgZ2FwOiAxMHB4O1xuICAgICAgICBtYXJnaW4tdG9wOiAyMHB4O1xuXG4gICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDUwMHB4KSB7XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgICAgZ2FwOiAxMHB4O1xuXG4gICAgICAgICAgICBidXR0b24ge1xuICAgICAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxufSJdfQ== */